import { render, staticRenderFns } from "./UploadMedia.vue?vue&type=template&id=bfeadba2&scoped=true&"
import script from "./UploadMedia.vue?vue&type=script&lang=js&"
export * from "./UploadMedia.vue?vue&type=script&lang=js&"
import style0 from "./UploadMedia.vue?vue&type=style&index=0&id=bfeadba2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfeadba2",
  null
  
)

export default component.exports